(function() {
  'use strict';

  angular.module('app.forms')
    .directive('fhFormSubcontractor', [function() {
      return {
        restrict: "E",
        scope: {
          dismissFunction: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        templateUrl: 'forms/fh-form-subcontractor',
        link: function() {},
        controller: [
          'FormService',
          'DeviceService',
          '$timeout',
          'AnalyticsService',
          function(
            FormService,
            DeviceService,
            $timeout,
            AnalyticsService
          ) {

            var self = this,
              prefillMode = false,
              prefillData = FormService.prefillForm(prefillMode, 'subcontractorsAndSuppliers');

            self.formData    = prefillData.formData;
            self.formResult  = prefillData.formResult;

            self.analyticsConfig = {
              googleAnalytics: {
                pageViewUrl: '/ajax-goals/subcontractors-and-suppliers'
              }
            };

            self.checkFormValidation = function(form) {
              self.triedSubmit = true;

              if (! form.$valid) {
                return;
              }

              processGetInTouchForm();
            };

            function processGetInTouchForm() {
              self.formResult.showForm = false;
              self.formResult.showLoader = true;

              prepareFormData();

              FormService.submit('/forms/subcontractors-and-suppliers', self.formData)
                .then(function(result) {
                  self.formResult = result;

                  AnalyticsService.logTrackingClick(self.analyticsConfig);

                  $timeout(function() {
                    self.dismissFunction();
                  }, 2000);
                });
            }

            function prepareFormData() {
              return;
            }

          }]
      };
    }]);
})();